import { useQuery } from '@tanstack/react-query';

import { getSessionMetrics } from '@/api/metrics';

/**
 * Fetch stored metrics (summary + points) for a completed session. Disabled
 * while a session is still active — the live WS hook owns that case.
 */
export function useSessionMetrics(id: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['session-metrics', id],
    queryFn: () => getSessionMetrics(id!),
    enabled: !!id && enabled,
    staleTime: 60_000,
  });
}
